import {
    Component,
    Prop,
    ComponentInterface,
    Watch,
    Event,
    EventEmitter,
    Host,
    h,
} from "@stencil/core";
import {
    IconSetMutator,
    IconSetResolver,
    RegistryInstance,
} from "./iconset-registry";

@Component({
    tag: "uic-iconset",
})
export class IconSet implements ComponentInterface {
    /**
     * The name of the iconset.
     */
    @Prop() name: string;

    /**
     * A function that translates an icon name to a URL where the corresponding SVG file exists.
     */
    @Prop() resolver: IconSetResolver;

    /**
     * A function that mutates the SVG element before it renders.
     */
    @Prop() mutator: IconSetMutator;

    /**
     * Emitted when the iconset has been added to the registry.
     */
    @Event() uicIconSetAdded: EventEmitter<string>;

    @Watch("name")
    @Watch("resolver")
    @Watch("mutator")
    handleUpdate() {
        this.addSet();
    }

    connectedCallback() {
        if (this.name && this.resolver) {
            this.addSet();
        }
    }

    disconnectedCallback() {
        if (this.name) {
            RegistryInstance.removeSet(this.name);
        }
    }

    addSet() {
        const { name, resolver, mutator } = this;
        RegistryInstance.addSet(name, resolver, mutator);
        this.uicIconSetAdded.emit(name);
    }

    render() {
        return <Host style={{ display: "none" }}></Host>;
    }
}
